import { render, staticRenderFns } from "./shortmessage.vue?vue&type=template&id=3744f3d6&scoped=true"
import script from "./shortmessage.vue?vue&type=script&lang=js"
export * from "./shortmessage.vue?vue&type=script&lang=js"
import style0 from "./shortmessage.vue?vue&type=style&index=0&id=3744f3d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3744f3d6",
  null
  
)

export default component.exports